export default function useDataConfiguration(props) {
  return {
    requestPolicy: 'network-only',
  }
}
